import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import PrivateRoute from './PrivateRoute';

import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import CustomersPage from '../pages/CustomersPage';
import QueriesPage from '../pages/QueriesPage';
import FollowupsPage from '../pages/FollowupsPage';
import BookingsPage from '../pages/BookingsPage';
import CreatePackagePage from '../pages/CreatePackagePage';
import ActivitiesPage from '../pages/ActivitiesPage';
import PackagesPage from '../pages/PackagesPage';

const AppRoutes = () => {
  return (
   <AuthProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><CustomersPage /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path="/queries" element={<PrivateRoute><QueriesPage /> </PrivateRoute>} />
        <Route path="/followups" element={<PrivateRoute><FollowupsPage /></PrivateRoute>} />
        <Route path="/bookings" element={<PrivateRoute><BookingsPage /></PrivateRoute>} />
        <Route path="/packages" element={<PrivateRoute><PackagesPage /></PrivateRoute>} />
        {/** QuotationBuilderPage route removed */}
        <Route path="/package/builder" element={<PrivateRoute><CreatePackagePage /></PrivateRoute>} />
        <Route path="/activities" element={<PrivateRoute><ActivitiesPage /></PrivateRoute>} />
      </Routes>
    </Router>
   </AuthProvider>
  );
};

export default AppRoutes;
